import { Box } from "@material-ui/core";
import { assetIds, InformationMessage, ThemedAsset } from "nemuru-components";
import React from "react";
import { ICON_TITLE_HEIGHT } from "../../../../../../config/config";
import IconTitle from "../../../../../shared/components/IconTitle";
import MainButton from "../../../../../shared/components/MainButton";
import Text from "../../../../../shared/components/Text";
import { useTheme } from "@material-ui/styles";

export default function NoIncomeMessage({ onCloseMessage }) {
  const { palette } = useTheme();
  return (
    <>
      <Box className="appear-anim">
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_MONEY_INCOMES}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId="FINANCIAL_DATA" />}
          subtitle={<Text tId="PROVIDE_MAIN_INCOME_SOURCE" />}
        />
        <Box m={1}>
          <InformationMessage
            variant={{
              type: "warning",
              icon: (
                <i className="material-icons-outlined" style={{ fontSize: 22 }}>
                  info
                </i>
              ),
            }}
            isScreenXs={false}
            messageContent={{
              title: <Text tId="NO_INCOME_TITLE" />,
              body: (
                <>
                  <Text tId="NO_INCOME_BODY" />
                  <br />
                  <br />
                  <strong>
                    <Text tId="NO_INCOME_BODY_DOC" />
                  </strong>
                </>
              ),
            }}
          />
        </Box>
      </Box>
      <MainButton onClick={onCloseMessage} />
    </>
  );
}
